import React from "react";
import Icon2 from "../../img/Icon2.jpg"
import Icon3 from "../../img/Icon3.png"
import Icon4 from "../../img/Icon4.png"
import Icon5 from "../../img/Icon5.png"
import {FormationContainer, FormationH1, FormationWrapper, FormationCard, FormationIcon, FormationH2, FormationP} from "../Formation/formationStyled"

const Formation = () => {
    return (
        <FormationContainer id='certificacao'>
            <FormationH1>Certificações</FormationH1>
            <FormationWrapper>
               

                <FormationCard>
                    <FormationIcon src={Icon2} />
                    <FormationH2> React</FormationH2>
                    <FormationP><a target={'_blank'} href="https://cursos.alura.com.br/degree/certificate/aee33d60-05a6-41a3-b833-4a0d41f4d613">Certificado React da Alura.</a></FormationP>
                </FormationCard>

                <FormationCard>
                    <FormationIcon src={Icon3} />
                    <FormationH2> JavaScript</FormationH2>
                    <FormationP><a target={'_blank'} href="https://cursos.alura.com.br/certificate/a0c375f8-b505-4937-85c7-1e59929cc4ca">Certificado JavaScript da Alura.</a></FormationP>
                </FormationCard>

                <FormationCard>
                    <FormationIcon src={Icon4} />
                    <FormationH2> Node Js</FormationH2>
                    <FormationP><a target={'_blank'} href="https://cursos.alura.com.br/degree/certificate/d5c90490-6a0a-495c-a866-8b2b80d2325a">Certificado Node Js da Alura.</a></FormationP>
                </FormationCard>

                <FormationCard>
                    <FormationIcon src={Icon5} />
                    <FormationH2> GitHub</FormationH2>
                    <FormationP><a target={'_blank'} href="https://cursos.alura.com.br/certificate/ee59061e-937d-4548-832f-9e51af632f1e">Certificado GitHub Alura.</a></FormationP>
                </FormationCard>
            </FormationWrapper>
        </FormationContainer>

    )

}

export default Formation;